// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3pcki","title":"Info_title__2IYDk","links":"Info_links__3hTHz","link":"Info_link__1H1l8","logo":"Info_logo__1BqZ4"};